/*
 * @Description:
 * @Autor: Sia
 * @Date: 2019-11-06 11:40:33
 * @LastEditors: Sia
 * @LastEditTime: 2020-01-13 16:15:08
 */
const queryRouter = {
  path: "/",
  component: () => import("@/components/report/home.vue"),
  children: [
    {
      path: "/query",
      name: "store-evalute-new",
      component: () => import("@/components/query/store/evaluate-new/evaluate.vue")
    },
    {
      path: "/store-evalute",
      name: "store-evalute",
      component: () => import("@/components/query/store/evaluate/evaluate.vue")
    },
    {
      path: "/store_nps",
      name: "store_nps",
      component: () => import("@/components/query/store/nps/index.vue")
    },
    {
      path: "/store_reward",
      name: "store_reward",
      component: () => import("@/components/query/store/reward/reward.vue")
    },
    {
      path: "/store_service",
      name: "store_service",
      component: () => import("@/components/query/store/service/service.vue")
    },
    {
      path: "/target_manage",
      name: "target_manage",
      component: () => import("@/components/query/store/target/target.vue")
    },
    {
      path: "/nofill_Members",
      name: "nofill_Members",
      component: () => import("@/components/query/store/nofill/nofill.vue")
    },
    {
      path: "/data",
      name: "data-entry",
      component: () => import("@/components/common/help/index.vue")
    },
    {
      path: "/logs",
      name: "logs",
      component: () => import("@/components/query/store/logs/index.vue")
    },
    {
      path: "/roast",
      name: "roast",
      component: () => import("@/components/query/store/roast/index.vue")
    },
  ]
};

export default queryRouter;
